/*
 * Footer link lists: accordion on mobile (closed by default), always open on desktop.
 * The markup is <details open>, so without JavaScript every list stays open and usable.
 */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function lists(scope = document) {
    return scope.querySelectorAll('details.footer-accordion');
  }

  function sync(scope) {
    lists(scope).forEach((details) => {
      if (!mobile.matches) details.open = true;
    });
  }

  // First paint on mobile: start collapsed.
  function collapse(scope) {
    if (!mobile.matches) return;
    lists(scope).forEach((details) => {
      if (details.dataset.accordionReady) return;
      details.dataset.accordionReady = 'true';
      details.open = false;
    });
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.footer-accordion__summary');
    // On desktop the lists are fixed open, so the heading is not a toggle.
    if (summary && !mobile.matches) event.preventDefault();
  });

  mobile.addEventListener('change', () => sync());

  const init = (scope) => {
    collapse(scope);
    sync(scope);
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
